module.exports = __webpack_public_path__ + "media/images/Yves01A-d95567b3.png";